























import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  InputItem,
  BooleanItem,
  YearSelect,
  TermSelect,
  CampusSelect,
  CourseGroupSelect,
  DepartmentSelect,
  WeekSelect,
  CourseTypeSelect,
  ProfessionSelect,
} from '@/components/form';

import { Plan, Record } from '@/domains/work';
import { Load } from '@/domains/system';
import { CoursePlanExec } from '@/domains/course';
import { isNullOrUndefined } from 'util';
import { listPlanApi, savePlanApi } from '@/api/work/PlanApi';

@Component({
  name: 'PlanUserSearch',
  components: {
    InputItem,
    BooleanItem,
    YearSelect,
    TermSelect,
    CampusSelect,
    CourseGroupSelect,
    DepartmentSelect,
    WeekSelect,
    CourseTypeSelect,
    ProfessionSelect,
  },
})
export default class PlanUserSearch extends Vue {
  /** 表单 */
  @Prop()
  private value: Record;

  /** 加载 */
  @Prop()
  private load: Load;

  /** bus */
  @Prop()
  private bus: Vue;

  /** 获取表单 */
  get form(): Record { return this.value; }

  /** 设置表单 */
  set form(value: Record) { this.$emit('input', value); }

  /** 查询 */
  private search() {
    if (!this.rules()) { return; }
    this.load.start('正在查询听课计划，请稍等。');
    this.bus.$emit('plan-user-table', []);
    listPlanApi(this.form).then((result: any) => {
      this.form.pageInfo.setPage(result);
      const list: Plan[] = Plan.builds(result.list);
      this.bus.$emit('plan-user-table', list);
      this.load.stop();
    }).catch(() => {
      this.load.stop();
    });
  }

  /** 校验 */
  private rules(): boolean {
    let result: boolean = true;
    if (isNullOrUndefined(this.form.plan.supervisor.person.id)) {
      this.createRuleFailNotify('未获取到督导信息，请稍后再试。');
      result = false;
    }
    return result;
  }

  /** 创建参数错误通知 */
  private createRuleFailNotify(message: string) {
    this.$notify.error({ title: '参数错误！', message });
  }

  private mounted() {
    this.bus.$on('plan-user-search', () => { this.search(); });
  }
}
